import React, { useEffect } from "react";
import {
  Container,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Divider,
} from "@mui/material";

import { useRouter } from "next/router";

import { SharedBookReducerProvider, useSharedBookReducer } from "./state";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

import useUser from "../../lib/useUser";

import { isNumber, toInteger } from "lodash";
import currency from "currency.js";
import moment from "moment";

import { request, gql } from "graphql-request";

import { ContactInfo } from "./ContactInfo";
import { Card } from "./Card";
import { Promocode } from "./Promocode";
import { SidebarHelp } from "./SidebarHelp";
import { SidebarNotes } from "./SidebarNotes";
import { SurfMainType } from "./SurfMainType";
import { SurfAbout } from "./SurfAbout";
import { SurfExperienceLevel } from "./SurfExperienceLevel";
import { SurfDateAndTime } from "./SurfDateAndTime";
import { SurfDatesAndTimes } from "./SurfDatesAndTimes";
import { SurfGroupCount } from "./SurfGroupCount";
import { SurfJoinCount } from "./SurfJoinCount";
import { SurfLargeGroupCount } from "./SurfLargeGroupCount";

import { SignupCard } from "./SignupCard";
import { SignupPartnerPkg } from "./SignupPartnerPkg";
import { SignupContactInfo } from "./SignupContactInfo";

import { useForm, useFormContext, FormProvider } from "react-hook-form";

const Book = (props) => {
  // initial state only!

  const router = useRouter();

  const search = router.asPath.split("?");
  var urlParams = new URLSearchParams(`?${search[1]}`);
  let peopleCount =
    urlParams.get("people") == toInteger(urlParams.get("people")).toString()
      ? urlParams.get("people")
      : 2;
  // console.log("search:", search, "TYPE:", urlParams.get("type"), router.asPath);
  const initialState = {
    saving: null,
    m: {
      main: urlParams.get("main") || "surf", // surf, bike, combo
      main_bike: {
        level: urlParams.get("level") || "beginner",
        timelength: toInteger(urlParams.get("timelength"))
          ? urlParams.get("timelength")
          : 2,
        own_bikes: 0,
        adults: toInteger(urlParams.get("adults"))
          ? urlParams.get("adults")
          : 1,
        kids: toInteger(urlParams.get("kids")) ? urlParams.get("kids") : 0,
      },
      // TODO: move surf to main_surf
      type: urlParams.get("type") || "single",
      singletype: urlParams.get("single") || "single", // 'master'
      grouppeople: peopleCount <= 4 ? peopleCount : 2,
      joinpeople: 1,
      biggrouppeople: 5,
      days: 1,
      start_date: urlParams.get("start_date") || moment().format("YYYY-MM-DD"),
      date_flexible: false,
      time: "instructor_recommended",
      time_other: "",
      //   startday: null, //moment().format('YYYY-MM-DD'), // today
      contactname: "",
      contactphone: "",
      contactemail: "",
      coupon: urlParams.get("promo") || "NEWYEARS24", //window.defaultPromo,
      notes: "",
    },
    promo: {
      applying: false,
      applied: false,
      code: null,
      details: null, // from server
      output: null, // output of processPromoCode (useApplyPromo)
      // {
      //   type: 'percent',
      //   percent: 0.15,
      //   desc: '15% End of Year Discount'
      // }
    },
    totals: {
      subtotal: 0,
      total: 0, // after discount applied
      totalValue: 0,
      totalIntValue: 0,
      discount: 0,
    },
    showSingleClasstype: true,
    showPeopleCounter: true,
    showPeopleCounterText: true,
    showDayCounter: true,
    showCalendar: true,
    showRecTimes: true,
    showContactCollector: true,
    prices: {
      // surfing
      multi_day_discount: 25,
      private_single: 199,
      private_master: 275,
      private_group_2: 175, // 149
      private_group_3: 150, // 125
      private_group_4: 125, // 99
      large_group: 99, // 90
      join_group: 99,
      // biking
      bike_noadult_surcharge_timelength_2: 10,
      bike_noadult_surcharge_timelength_3: 10,
      bike_adult_timelength_2: 10,
      bike_adult_timelength_3: 10,
      bike_adult_discount_timelength_2: 10,
      bike_adult_discount_timelength_3: 10,
      bike_kid_timelength_2: 10,
      bike_kid_timelength_3: 10,
      bike_ownbike_discount: 10,
    },
  };
  return (
    <SharedBookReducerProvider initialState={initialState}>
      <BookWrapped />
    </SharedBookReducerProvider>
  );
};

const BookWrapped = (props) => {
  const { user } = useUser();
  const stripe = useStripe();
  const elements = useElements();

  const [bookState, dispatch] = useSharedBookReducer();

  const onSubmit = async (data) => {
    //   // Block native form submission.
    //   event.preventDefault();

    dispatch({
      type: "MERGE",
      payload: {
        saving: true,
      },
    });

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    let stripeToken;
    let cardElement = elements.getElement(CardElement);

    if (cardElement) {
      const { error, token } = await stripe.createToken(cardElement);
      if (error) {
        // credit card error
        console.log("[error]", error);
        alert("Error with Credit Card, please try again");

        dispatch({
          type: "MERGE",
          payload: {
            saving: null,
          },
        });
        return;
      } else {
        console.log("[token]", token);
        stripeToken = token.id;
      }
    } else {
      if (!bookState.m.skip_card) {
        stripeToken = "adminskip";
      } else {
        stripeToken = "signup";
      }
    }

    const lessonObj = {
      ...data,
      promo_code: bookState.promo.code,
      totalamount: bookState.totals.totalValue,
      stripeToken,
    };

    console.log("lessonObj:", lessonObj, bookState.totals, bookState.m);
    // dispatch({
    //   type: "MERGE",
    //   payload: {
    //     saving: null,
    //   },
    // });
    // return;

    try {
      const lessonResp = await request(
        `/api/graphql`,
        gql`
          mutation lessonBook($data: JSON) {
            lessonBook(data: $data) {
              success
              message
              data
              error
            }
          }
        `,
        {
          data: lessonObj,
        }
      );

      console.log("LessonResp:", lessonResp);

      // Failed?
      if (!lessonResp?.lessonBook?.success) {
        if (lessonResp?.lessonBook?.error?.card == "failed") {
          alert(
            "Sorry, there was a problem charging that card. Please check your card details and try agin. "
          );
        } else {
          alert(
            "Sorry, there was a problem saving your lesson. Please try again or contact us via phone!"
          );
        }
        dispatch({
          type: "MERGE",
          payload: {
            saving: null,
          },
        });
        return;
      }

      // Redirect to viewing the lesson
      const { id, rand } = lessonResp.lessonBook.data;
      window.location.href = `/book/v/${rand}`;
      return; // dont dispatch the "saving" update!
    } catch (err) {
      console.error("ERR:", err);
      alert(
        "Sorry, we encountered an error. Please check the details of your lesson and try again. Please contact us by phone if you continue to have issues!"
      );
    }

    dispatch({
      type: "MERGE",
      payload: {
        saving: null,
      },
    });
  };

  const methods = useForm();
  const onError = (data) => {
    alert("Unable to complete, please check fields and try again!");
    console.log("ERROR:", data);
  };

  // calculation of costs
  useApplyPromo();

  //   console.log("bookstate:", bookState);
  return (
    <div style={{ paddingBottom: "24px" }}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
          <Grid container spacing={3}>
            <Grid item md={7}>
              {/* <div>
                <Button onClick={methods.handleSubmit(onSubmit, onError)}>
                  FINISH
                </Button>
              </div> */}
              <SurfMainType />
              <SurfAbout />
              <br />
              {bookState.m.type === "single" ? <SurfExperienceLevel /> : ""}
              {bookState.m.type === "group" ? <SurfGroupCount /> : ""}
              {bookState.m.type === "join" ? <SurfJoinCount /> : ""}
              {bookState.m.type === "large-group" ? (
                <div style={{}}>
                  <SurfLargeGroupCount />
                </div>
              ) : (
                ""
              )}
              {["join", "surfit", "corp"].indexOf(bookState.m.type) > -1 ? (
                <div style={{ marginTop: 24 }}>
                  <Divider />
                  <br />
                  <SurfDateAndTime />
                </div>
              ) : (
                <div style={{ marginTop: 24 }}>
                  <Divider />
                  <br />
                  <SurfDatesAndTimes />
                </div>
              )}
              <br />
              <Divider />
              <br />
              <ContactInfo />
              <br />
              <br />
              <Divider />
              <br />
              {["partner_package"].indexOf(bookState.promo.details?.type) ===
                -1 ? (
                ["surfit", "corp"].indexOf(bookState.m.type) > -1 ? (
                  <SignupContactInfo
                    onComplete={methods.handleSubmit(onSubmit, onError)}
                  />
                ) : (
                  <SignupCard
                    onComplete={methods.handleSubmit(onSubmit, onError)}
                  />
                )
              ) : null}
              {["partner_package"].indexOf(bookState.promo.details?.type) >
                -1 ? (
                <SignupPartnerPkg />
              ) : null}
            </Grid>
            <Hidden smDown>
              <Grid item md={1}></Grid>
            </Hidden>
            <Grid item md={4}>
              <SidebarHelp />
              <br />
              <Promocode />
              <br />
              <SidebarNotes />
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </div>
  );
};

const useApplyPromo = () => {
  const [bookState, dispatch] = useSharedBookReducer();

  const processPromoCode = (promoDetails, inputData) => {
    function doesNotApplyFunc(msg) {
      return {
        discount: "notapply",
        message:
          msg ||
          "Promo code does not apply to this lesson type. Please check description of promo code",
        messageStatus: "is-error",
      };
    }
    try {
      if (promoDetails?.type == "discount") {
        let func = promoDetails.data.rules;
        if (!func) {
          console.error("no func");
          return null;
        }
        const output = Function(
          "data",
          "doesNotApply",
          func
        )(inputData, doesNotApplyFunc);
        // console.log("output123:", output);
        return output;
      } else {
        // console.log("no promoDetails", promoDetails);
      }
    } catch (err) {
      console.error("failed processPromoCode:", err);
    }
    return null;
  };

  useEffect(() => {
    // Process promocode
    const output = processPromoCode(bookState.promo.details, bookState.m);
    dispatch({
      type: "MERGE",
      payload: {
        promo: {
          output,
        },
      },
    });
    // console.log("afer proces", output);
  }, [JSON.stringify([bookState.promo.details, bookState.m])]);

  // Update TotalCost
  useEffect(() => {
    const subtotal = getSubTotal(bookState);
    const total = getTotal(bookState, subtotal);

    dispatch({
      type: "MERGE",
      payload: {
        totals: {
          subtotal: subtotal.format(),
          total: total.format(),
          totalValue: total.value,
          totalIntValue: total.intValue,
          discount: total.subtract(subtotal).format(),
        },
      },
    });
  }, [JSON.stringify([bookState.m, bookState.promo])]);

  const getSubTotal = (bookState) => {
    var gpcost = 0;
    var peoplecount = 1;
    var daycount = parseInt(bookState.m.days, 10);
    var total = currency(0);
    var prices = bookState.prices;

    switch (bookState.m.main) {
      case "bike":
        var timelength = bookState.m.main_bike.timelength;

        // adult cost (or surcharge)
        var adults = parseInt(bookState.m.main_bike.adults, 10) || 0;
        if (adults === 0) {
          // add surcharge
          total = total.add(
            prices[`bike_noadult_surcharge_timelength_${timelength}`]
          );
        } else {
          var adultsTotal = currency(
            prices[`bike_adult_timelength_${timelength}`]
          ).multiply(adults);
          total = total.add(adultsTotal);

          var discountTotal = currency(
            prices[`bike_adult_discount_timelength_${timelength}`]
          ).multiply(adults - 1);
          total = total.subtract(discountTotal);
        }

        // kid cost
        var kids = parseInt(bookState.m.main_bike.kids, 10) || 0;
        var kidsTotal = currency(
          prices[`bike_kid_timelength_${timelength}`]
        ).multiply(kids);
        total = total.add(kidsTotal);

        // own bikes
        var ownBikes = parseInt(bookState.m.main_bike.own_bikes, 10) || 0;
        var ownBikeDiscountTotal = currency(
          prices[`bike_ownbike_discount`]
        ).multiply(ownBikes);
        total = total.subtract(ownBikeDiscountTotal);

        console.log("biketotal:", total.format(), [
          timelength,
          adults,
          kids,
          ownBikes,
        ]);

        break;

      case "surf":
        switch (bookState.m.type) {
          case "single":
            switch (bookState.m.singletype) {
              case "single":
                if (daycount == 1) {
                  total = total.add(prices.private_single);
                } else {
                  total = total.add(
                    prices.private_single * daycount -
                    prices.multi_day_discount * (daycount - 1)
                  ); // $25 discount
                  console.log("TOTAL:", total.format());
                }
                break;
              case "master":
                if (daycount == 1) {
                  total = total.add(prices.private_master);
                } else {
                  total = total.add(
                    prices.private_master * daycount -
                    prices.multi_day_discount * (daycount - 1)
                  ); // $25 discount
                }
                break;
            }

            break;

          case "group":
            gpcost = 0;
            peoplecount = parseInt(bookState.m.grouppeople, 10);

            switch (peoplecount) {
              case 2:
                gpcost = prices.private_group_2;
                break;
              case 3:
                gpcost = prices.private_group_3;
                break;
              case 4:
                gpcost = prices.private_group_4;
                break;
              // case 5:
              //   gpcost = 90;
              //   break;
            }
            gpcost = peoplecount * gpcost;

            if (daycount == 1) {
              total = total.add(gpcost);
            } else {
              total = total.add(
                gpcost * daycount - prices.multi_day_discount * (daycount - 1)
              ); // $25 discount
            }

            break;

          case "large-group":
            peoplecount = parseInt(bookState.m.biggrouppeople, 10);
            gpcost = peoplecount * prices.large_group; // $80 cost per person of Large Group

            if (daycount == 1) {
              total = total.add(gpcost);
            } else {
              total = total.add(
                gpcost * daycount - prices.multi_day_discount * (daycount - 1)
              ); // $25 discount
            }

            break;

          case "join":
            gpcost = 0;
            peoplecount = parseInt(bookState.m.joinpeople, 10);

            switch (peoplecount) {
              case 1:
                gpcost = prices.join_group;
                break;
              case 2:
                gpcost = prices.join_group;
                break;
              case 3:
                gpcost = prices.join_group;
                break;
              case 4:
                gpcost = prices.join_group;
                break;
              // case 5:
              //   gpcost = 90;
              //   break;
            }
            gpcost = peoplecount * gpcost;

            // make sure it is $25 off PER PERSON for each day > 1

            if (daycount == 1) {
              total = total.add(gpcost);
            } else {
              const sub =
                prices.multi_day_discount * peoplecount * (daycount - 1);
              total = total.add(gpcost * daycount - sub); // $25 discount
            }

            break;

          default:
            break;
        }
        break;
    }

    if (bookState.m.coupon == "testlaunchinvalid") {
      total = currency(2.0);
    }

    // console.log('totalamount', total);

    return total;
  };

  const getTotal = (bookState, subtotal) => {
    if (bookState.promo.details) {
      let mainType = bookState.promo.details.type;

      switch (mainType) {
        case "discount":
          // discount w/ rules (default)

          let promoData = bookState.promo.output;
          if (!promoData || !promoData.discount) {
            break;
          }
          switch (promoData.discount) {
            case "percent":
              return subtotal.multiply(
                1 - parseInt(promoData.amount, 10) / 100
              );

            case "dollars":
              return subtotal.subtract(parseInt(promoData.amount, 10));

            case "setprice":
              return currency(parseInt(promoData.amount, 10));

            case "notapply":
              break;

            default:
              break;
          }
          break;

        case "percent":
          return subtotal.multiply(
            1 - parseInt(bookState.promo.details.data.percent, 10) / 100
          );

        case "partner_package":
          return currency(0);
        default:
          break;
      }
    }
    return subtotal;
  };

  return null;
};

export default Book;
